import { LoginOutlined } from '@mui/icons-material';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';
import { Box, Button, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGlobalState } from '../../context/GlobalState';

const ProfileMenu = (props: { toggleMenu: (b?: boolean) => void }) => {
  const globalState = useGlobalState();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogout = () => {
    globalState.handleLogOut();
  };
  return (
    <Box sx={{ textAlign: 'center' }}>
      {globalState.user ? (
        <>
          <Tooltip title={globalState.user.email}>
            <Button
              variant='contained'
              startIcon={<LogoutOutlined />}
              color='secondary'
              sx={{ width: '90%' }}
              onClick={handleLogout}
            >
              {t('profile.logout')}
            </Button>
          </Tooltip>
        </>
      ) : (
        <Button
          variant='contained'
          startIcon={<LoginOutlined />}
          color='secondary'
          sx={{ width: '90%' }}
          onClick={() => {
            props.toggleMenu(false);
            navigate('/login', { replace: true });
          }}
        >
          {t('profile.login')}
        </Button>
      )}
    </Box>
  );
};

export default ProfileMenu;
